import React from 'react';

// windowオブジェクトにgtagを追加
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const Hero: React.FC = () => {
  const handleMailtoClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  const handleLineClick = () => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17931041617/eH8qCOvAwPIbENH2l-ZC',
        'value': 1.0,
        'currency': 'JPY'
      });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/5e182d52a94dfeeda6703180d188c585/5e4aed944ab7970ec766e17436cefe42.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900/75 via-navy-800/65 to-navy-900/75"></div>
      
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 lg:px-12 py-32 md:py-40">
        <div className="text-left">
          <h1 className="font-noto text-5xl md:text-7xl font-bold text-white mb-12 leading-tight tracking-wide">
            <span className="block text-beige-200 mb-4">負動産を、</span>
            <span className="block">手放すという選択。</span>
          </h1>
          
          <p className="font-noto text-xl md:text-2xl text-white/95 mb-12 leading-relaxed max-w-3xl font-light">
            売れない、貸せない、管理できない。<br />
            その土地の悩み、弁護士が法的に解決します。
          </p>

          {/* 3つの重要ポイント */}
          <div className="mb-16 space-y-4 max-w-3xl">
            <div className="flex items-start gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-home-4-line text-beige-300 text-2xl"></i>
              </div>
              <div>
                <p className="font-noto text-white/95 text-base leading-relaxed">
                  <strong className="text-beige-200">対象：</strong>農地・山林・空き家・市街化調整区域などの"売れない土地"
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-beige-300 text-2xl"></i>
              </div>
              <div>
                <p className="font-noto text-white/95 text-base leading-relaxed">
                  <strong className="text-beige-200">対応エリア：</strong>愛知・岐阜・三重・静岡
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-money-yen-circle-line text-beige-300 text-2xl"></i>
              </div>
              <div>
                <p className="font-noto text-white/95 text-base leading-relaxed">
                  <strong className="text-beige-200">費用：</strong>着手金0円＋成功報酬110万円／初回法律相談無料
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-6">
            <a
              href="mailto:shin.kato@tomidashimaoka.com?subject=【相談】負動産の法的処分&body=お名前：%0D%0Aご連絡先：%0D%0A物件種別（山林/農地/空き家）：%0D%0A所在地市町村：%0D%0A筆数・目安面積：%0D%0A現況（写真があれば添付可）：%0D%0Aご相談内容："
              onClick={handleMailtoClick}
              className="inline-flex items-center justify-center gap-3 bg-beige-400 hover:bg-beige-500 text-navy-900 px-10 py-5 rounded-lg transition-all font-noto font-semibold text-lg shadow-2xl cursor-pointer whitespace-nowrap hover:scale-105 duration-300"
            >
              <i className="ri-mail-heart-line text-2xl"></i>
              メールで初回相談の予約
            </a>
            
            <a
              href="https://lin.ee/34dhahY"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLineClick}
              className="inline-flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white px-10 py-5 rounded-lg transition-all font-noto font-semibold text-lg shadow-2xl cursor-pointer whitespace-nowrap hover:scale-105 duration-300"
            >
              <i className="ri-line-fill text-2xl"></i>
              LINEで初回相談の予約
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
